<vwui-card>
    <vwui-card-header>
        {{ 'PROJECT_NOTES.title' | translate }}
        <vwui-button slot="actions" class="is-secondary" [ariaLabel]="'PROJECT_NOTES.modal.title' | translate" (click)="openAddNoteModal()">
            {{ 'BUTTON.create' | translate }}
        </vwui-button>
    </vwui-card-header>
    <vwui-card-body>
        @if (isLoading()) {
            <vwui-spinner></vwui-spinner>
        } @else if (notes().length === 0) {
            <p class="empty-state">{{ 'PROJECT_NOTES.empty' | translate }}</p>
        } @else {
            <ul class="notes-list">
                @for (note of notes(); track trackNote($index)) {
                    <li class="notes-list__item">
                        <div class="notes-list__meta">
                            <span class="notes-list__date">{{ note.date }} {{ note.time }}</span>
                            <span class="notes-list__user">{{ getUser(note) }}</span>
                        </div>
                        <div class="notes-list__message">{{ note.message }}</div>
                    </li>
                }
            </ul>
        }
    </vwui-card-body>
</vwui-card>
